module.exports = __webpack_public_path__ + "img/DEE8E8_A6B5B5_BCCCCC_BAC4C4-256px.24aceb0f.png";